// generated by genversion
export const version = '1.0.0-beta.11';
//# sourceMappingURL=version.js.map